import React, { Fragment } from 'react';
import Button from "@mui/material/Button/Button.js";
import MenuItem from "@mui/material/MenuItem/MenuItem.js";
import Tooltip from "@mui/material/Tooltip/Tooltip.js";
import MenuLink from "./NavMenuLink.js";
import NavMenuButton from "./NavMenuButton.js";
import UserAvatar from "../UserAvatar.js";

/**
 * A user menu for the NavBar
 */
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var UserMenu = function UserMenu(_ref) {
  var user = _ref.user,
    logout = _ref.logout,
    login = _ref.login,
    loginText = _ref.loginText,
    children = _ref.children,
    showAccountLink = _ref.showAccountLink,
    accountUrl = _ref.accountUrl;
  return /*#__PURE__*/_jsx(Fragment, {
    children: user ? /*#__PURE__*/_jsxs(NavMenuButton, {
      label: /*#__PURE__*/_jsx(UserAvatar, {
        user: user,
        size: "xsmall",
        "data-qe": "menu-avatar"
      }),
      "aria-label": "Planet Account ".concat(user.name),
      children: [showAccountLink && /*#__PURE__*/_jsx(MenuLink, {
        title: "Manage Account",
        component: "a",
        target: "_blank",
        rel: "noreferrer noopener",
        href: accountUrl,
        "data-qe": "menu-account-settings",
        children: "My Account"
      }), children, logout && /*#__PURE__*/_jsx(MenuItem, {
        onClick: logout,
        "data-qe": "menu-logout",
        children: "Log Out"
      })]
    }) : login && /*#__PURE__*/_jsx(Tooltip, {
      title: "Log in to your Planet account",
      children: /*#__PURE__*/_jsx(Button, {
        color: "primary",
        onClick: login,
        children: loginText
      })
    })
  });
};
UserMenu.defaultProps = {
  loginText: 'Log In',
  showAccountLink: true,
  accountUrl: 'https://www.planet.com/account/'
};
export default UserMenu;